//@flow
import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import { Upload, Flex } from '../'
import { ControllerError } from './'

type UploadControllerProps = {
  name: string,
  label?: string,
  rules?: any,
  [key: string]: any
}

const UploadController = ({ name, label, rules, ...props }: UploadControllerProps) => {
  const { errors } = useFormContext()
  return (
    <Flex column>
      <Controller
        label={label}
        name={name}
        render={({ field: { onChange, value = [] } }) => (
          <Upload id={`${name}-upload`} label={label} value={value} onChange={onChange} {...props} />
        )}
        rules={rules}
      />
      <ControllerError errors={errors} name={name} />
    </Flex>
  )
}

export { UploadController }
